const features = [
  {
    icon: 'ri-refresh-line',
    title: 'Updated Daily',
    description: 'Our spreadsheet links are refreshed every 24 hours to ensure you never hit a dead end. Dead links are removed and new finds are added continuously.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20desk%20setup%20with%20laptop%20showing%20colorful%20data%20dashboard%2C%20coffee%20cup%2C%20notebook%2C%20warm%20morning%20sunlight%20from%20window%2C%20clean%20productive%20workspace&width=600&height=400&seq=feature-update-v4&orientation=landscape',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Seller Verified',
    description: 'Every seller and product link goes through a community verification process before being added to our curated Sugargoo spreadsheet directory.',
    image: 'https://readdy.ai/api/search-image?query=Closeup%20of%20hands%20holding%20magnifying%20glass%20over%20product%20tags%20with%20verified%20badge%2C%20warm%20wooden%20desk%20background%2C%20soft%20natural%20lighting%2C%20trust%20and%20quality%20concept&width=600&height=400&seq=feature-verify-v4&orientation=landscape',
  },
  {
    icon: 'ri-link-m',
    title: 'Safe Redirects',
    description: 'All external links use secure redirects with nofollow attributes. We never track your clicks or collect personal shopping data.',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20security%20concept%20with%20glowing%20shield%20icon%20and%20connected%20nodes%20on%20warm%20gradient%20background%2C%20clean%20modern%20tech%20illustration%20style&width=600&height=400&seq=feature-safe-v4&orientation=landscape',
  },
];

export default function FeatureGrid() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-8 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <p className="text-xs font-semibold text-foreground-400 uppercase tracking-widest mb-4 font-label">
          Why Trust Our Guides
        </p>
        <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 font-heading leading-[1.15] mb-14 max-w-2xl">
          Curated Sugargoo Finds<br />&amp; Verified Links
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:shadow-sm"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                />
                <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
              </div>
              <div className="px-7 pb-7 md:px-9 md:pb-9 -mt-4 relative z-10">
                <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-4">
                  <i className={`${feature.icon} text-accent-600 text-xl`}></i>
                </div>
                <h3 className="text-lg font-bold text-foreground-900 font-heading mb-3">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}